export default __webpack_public_path__ + "static/media/comment.737b3536.svg";